// utils/speechRecognitionHelpers.js
// Helper functions for speech recognition chat input

export function handleSpeechInputChange(setInput, finalRef) {
  return (e) => {
    setInput(e.target.value);
    finalRef.current = e.target.value;
  };
}

export function handleSpeechKeyDown(event, stopListening, handleSendMessage) {
  if (event.key === "Enter") {
    event.preventDefault();
    stopListening();
    handleSendMessage();
  }
}

export function startListening(recognitionRef, setListening, input, finalRef) {
  if (!recognitionRef.current) return;
  try {
    recognitionRef.current.start();
    if (input) {
      finalRef.current = input + ' ';
    }
    setListening(true);
  } catch (err) {
    console.warn(err);
  }
}

export function stopListening(recognitionRef, setListening) {
  if (!recognitionRef.current) return;
  recognitionRef.current.stop();
  setListening(false);
}
